// Import and register all your controllers from the importmap under controllers/*

import { application } from "./application"
import { registerControllers } from 'stimulus-vite-helpers'

// Eager load all controllers defined in the import map under controllers/**/*_controller
//eagerLoadControllersFrom("controllers", application)

//import { lazyLoadControllersFrom } from "@hotwired/stimulus-loading"
//lazyLoadControllers From("components", application)

// Lazy load controllers as they appear in the DOM (remember not to preload controllers in import map!)
// import { lazyLoadControllersFrom } from "@hotwired/stimulus-loading"
// lazyLoadControllersFrom("controllers", application)
const controllers = import.meta.glob('./*_controller.js', { eager: true })
registerControllers(application, controllers)